var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.voc.h1[_vm.lang]))]),_c('div',{staticClass:"front-buttons"},[_c('router-link',{staticClass:"button",attrs:{"to":"/lists"}},[_vm._v(_vm._s(_vm.voc.lists[_vm.lang]))]),_c('router-link',{staticClass:"button",attrs:{"to":"/contacts"}},[_vm._v(_vm._s(_vm.voc.contacts[_vm.lang]))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }